export default __webpack_public_path__ + "static/media/soccer-jersey.50521664.svg";